/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./BaseQuery";

const billingApi = createApi({
  reducerPath: "billingApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Accounts", "users"],
  endpoints: (builder) => ({
    createSubscription: builder.mutation<any, any>({
      query: ({ plan, activateUsers, activateTracking }) => ({
        url: `subscribe?users=${activateUsers}&accounts=${activateTracking}`,
        method: "POST",
        body: { plan },
      }),
    }),
    cancelSubscription: builder.mutation<any, any>({
      query: (plan) => ({
        url: `cancel-subscription`,
        method: "POST",
        body: { ...plan },
      }),
      invalidatesTags: ["Accounts", "users"],
    }),
    getSubscriptionStatus: builder.query<any, void>({
      query: () => "/check-subscription",
      transformResponse: (response: any) => response,
    }),
  }),
});

export const {
  useCreateSubscriptionMutation,
  useGetSubscriptionStatusQuery,
  useCancelSubscriptionMutation,
} = billingApi;

export default billingApi;
